import type { ProductListItemModel } from 'autogen/swagger/all';
import ProductGridWithLevels from '../../shared/productList/components/ProductGridWithLevels';

export default function MediumProductRecommendation({ items }: { items: ProductListItemModel[] }) {
    return <ProductGridWithLevels itemConfigType="verticalProductItem" items={items} />;
}
